import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import Loader from '@components/Utilities/Loader';
import AlertMessage from '@components/Utilities/AlertMessage';
import { useAppUpdateChecker } from '@hooks/useAppUpdateChecker';

const Auth: React.FunctionComponent = () => {
    const { isLoading } = useSelector((state: RootReducer) => state.app);
    // En login no hay nada que perder: si hay versión nueva, recarga sola
    // (una tablet que cerró caja se queda aquí toda la noche)
    useAppUpdateChecker({ alwaysAutoReload: true });

    return (
        <Box>
            <Box />
            <CssBaseline />
            <Outlet />
            {isLoading && <Loader />}
            <AlertMessage />
        </Box>
    );
};
export default Auth;
